import { primaryColors } from '@assets/styles/helpers/colors.styles'
import CircularProgress from '@mui/material/CircularProgress'

interface LoaderProps {
  /**
   * `tiny` is 14px, the size of an `icon-small` glyph — for standing in for an
   * icon inside a control without changing the control's footprint.
   */
  size: 'tiny' | 'small' | 'medium' | 'large'
}

function Loader(props: LoaderProps) {
  const { size } = props
  const sizeValue = (() => {
    switch (size) {
      case 'tiny':
        return 14
      case 'small':
        return 20
      case 'medium':
        return 40
      case 'large':
        return 64
      default:
        return 40
    }
  })()

  return (
    <CircularProgress
      sx={{
        width: `${sizeValue}px !important`,
        height: `${sizeValue}px !important`,
        color: primaryColors.orange
      }}
    />
  )
}

export default Loader
